import { render } from "./TabsModalAnalise.vue?vue&type=template&id=9275a416"
import script from "./TabsModalAnalise.vue?vue&type=script&lang=js"
export * from "./TabsModalAnalise.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__